export default {
    'CUSTOMISATION.FEEDBACK': 'Appointment feedback in Calizy Pro',
    'CUSTOMISATION.UNAVAILABILITY': 'Create unavailability in Calizy Pro',
};
